import { useEffect, useRef } from 'react';
import { useFeatureFlags } from '../api/featureSwitch-api';
import { calculateToTotalMonths, calculateTotalMonths } from './utils';
const castThroughSchema = (schema, values) => {
    if (!schema)
        return values;
    try {
        return schema.cast(values, { assert: false });
    }
    catch {
        return values;
    }
};
export const useFormAutoSave = (subscribe, onSync, schema) => {
    const schemaRef = useRef(schema);
    schemaRef.current = schema;
    useEffect(() => {
        const unsubscribe = subscribe({
            formState: {
                values: true,
            },
            callback: ({ values }) => {
                if (values) {
                    onSync(castThroughSchema(schemaRef.current, values));
                }
            },
        });
        return unsubscribe;
    }, [subscribe, onSync]);
};
export const useLengthInMonths = ({ financingProgram, fieldPrefix, years, monthsUnderOneYear, setValue, clearErrors, }) => {
    const [flags] = useFeatureFlags(financingProgram);
    const useExactMonths = flags?.useExactMonthsUnderOneYear ?? false;
    const yearsValue = +(years ?? 0);
    const isLessThanOneYear = useExactMonths && yearsValue === -1;
    useEffect(() => {
        const totalPath = `${fieldPrefix}.months`;
        const monthsPath = `${fieldPrefix}.monthsUnderOneYear`;
        const months = isLessThanOneYear ? +(monthsUnderOneYear ?? 0) : 0;
        if (!isLessThanOneYear && monthsUnderOneYear) {
            setValue(monthsPath, 0);
        }
        const total = useExactMonths ? calculateToTotalMonths(yearsValue, months) : calculateTotalMonths(yearsValue);
        setValue(totalPath, total);
        if (total > 0) {
            clearErrors(totalPath);
        }
    }, [clearErrors, setValue, fieldPrefix, yearsValue, monthsUnderOneYear, isLessThanOneYear, useExactMonths]);
    return { isLessThanOneYear };
};
